<mat-form-field
  [colorContrastAuto]="true"
  contrastMode="auto"
  appearance="outline"
  class="sia-inputs-full sia-input"
  floatLabel="always"
  [class]="inputClass()"
  [subscriptSizing]="showBottomMargin() ? 'fixed' : 'dynamic'"
>
  <mat-label>
    {{ label() | siaTranslate }}
    @if (info()) {
      <span
        [siaTooltip]="info() ?? ''"
        position="right"
        class="sia-info"
        [innerHTML]="infoIcon()"
      ></span>
    }
  </mat-label>

  <input
    matInput
    [ngModel]="value()"
    (ngModelChange)="value.set($event)"
    [disabled]="isDisabled()"
    [id]="id() ?? ''"
    [tabindex]="tabDisabled() ? '-1' : '0'"
    [siaTooltip]="fieldErrors()"
    [disable]="!visibleTooltip()"
    matTooltipClass="sia-tooltip"
  />

  @if (showBottomMargin()) {
    <mat-hint
      sia-error-hint
      [statusMessage]="statusMessage()"
      [statusMessages]="statusMessages()"
    ></mat-hint>
  }
</mat-form-field>

<ngx-colors
  ngx-colors-trigger
  colorsAnimation="popup"
  format="hex"
  [ngModel]="value()"
  (ngModelChange)="value.set($event)"
  [acceptLabel]="'Seleziona' | siaTranslate"
  [cancelLabel]="'Cancella' | siaTranslate"
  [style]="
    isDisabled()
      ? 'pointer-events: none; opacity: 0.6'
      : 'pointer-events: auto; opacity: 1'
  "
  [tabindex]="isDisabled() ? '-1' : '0'"
></ngx-colors>
